<template>
  <div class="text-center d-inline-flex fluid">
    <v-menu
      v-model="menu"
      scroll-strategy="none"
      :close-on-content-click="false"
      location="bottom"
    >
      <template v-slot:activator="{ props }">
        <v-btn size="small" variant="text" v-bind="props" :class="{ active: menu }">
          {{ filterName }}
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </template>

      <v-card max-width="800" max-height="500" class="overflow-y-auto">
        <v-list class="main-filter-list" v-model:opened="openGroups">
          <template v-for="group in items" :key="group.productId">
            <v-list-group :value="group.productId">
              <!-- Group -->
              <template v-slot:activator="{ props }">
                <v-list-item v-bind="props">
                  <template v-slot:prepend>
                    <v-checkbox
                      v-model="group.selected"
                      hide-details
                      density="compact"
                      @click.stop
                      @change="onGroupSelected(group)"
                    ></v-checkbox>
                  </template>
                  <v-list-item-title>
                    {{ group.productName }}
                  </v-list-item-title>
                </v-list-item>
              </template>
              <!-- Single product -->
              <v-list-item
                v-for="child in group.items"
                :key="child.productId"
                :disabled="child.disabled"
              >
                <v-checkbox
                  v-model="child.selected"
                  :label="child.productName"
                  hide-details
                  density="compact"
                  @change="onChildSelected(group)"
                ></v-checkbox>
              </v-list-item>
            </v-list-group>
            <v-divider
              vertical
              class="divider-vertical"
            ></v-divider>
            <v-divider
              class="divider-horizontal"
            ></v-divider>
          </template>
        </v-list>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="onApply">
            {{ $t("common.actions.ok") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: ["filterName", "availableItems", "selectedItems"],
  emits: ["update:selectedItems"],
  data: () => ({
    menu: false,
    items: [],
    openGroups: [],
  }),
  created() {
    this.setSelection()
  },
  computed: {
    expandItems() {
      return this.$vuetify.display.lgAndUp
    },
  },
  methods: {
    onApply() {
      // Filters refreshed after every checkbox click, so there is no need to refresh them here
      this.menu = false
    },
    setSelection() {
      this.items = this.availableItems
      this.openGroups = this.expandItems
        ? this.items.map((group) => group.productId)
        : []
      const flattened = this.items.map((group) => group.items).flat()

      // single product
      for (let ix = 0; ix < flattened.length; ix++) {
        const selItem = this.selectedItems.find((si) => {
          return si.productId === flattened[ix].productId
        })
        if (selItem) {
          flattened[ix].selected = true
        } else {
          flattened[ix].selected = false
        }
      }

      // groups
      const selectedGroups = this.selectedItems.filter((i) => i.items)
      for (let group of this.items) {
        const selectedGroup = selectedGroups.find(
          (selectedGroup) => selectedGroup.productId == group.productId
        )
        if (selectedGroup) {
          group.selected = true
          for (let child of group.items) {
            child.selected = true
            child.disabled = true
          }
        } else {
          group.selected = false
          for (let child of group.items) {
            child.disabled = false
          }
        }

        group.highlighted =
          group.selected ||
          group.count == group.items.filter((child) => child.selected).length
      }
    },
    onGroupSelected(group) {
      group.highlighted = group.selected
      for (let child of group.items) {
        child.selected = group.selected
        child.disabled = group.selected
      }

      this.refreshFilters()
    },
    onChildSelected(group) {
      group.highlighted =
        group.selected ||
        group.count == group.items.filter((child) => child.selected).length

      this.refreshFilters()
    },
    refreshFilters() {
      const selected = this.items.flatMap((group) =>
        group.selected ? group : group.items.filter((it) => it.selected)
      )
      this.$emit("update:selectedItems", selected)
    },
  },
  watch: {
    menu(newMenuState) {
      if (newMenuState) {
        this.setSelection()
      }
    },
  },
}
</script>

<style>
.main-filter-list {
  display: flex;
  /* flex-wrap: wrap;  */
  * .v-list-item__action {
    margin-right: 1rem !important;
  }
  * .v-list-group__header {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  * .v-list-group__header__append-icon {
    margin: 0 !important;
    min-width: auto !important;
  }
  .v-list-group {
    margin-right: 0.5rem;
    margin-left: 0.5rem;
  }

  /* 1248px = material lg - 16px scroll */
  @media (width < 1248px) {
    flex-direction: column;
  }
}
.divider-horizontal {
  @media (width >= 1248px) {
    display: none;
  }
}
.divider-vertical {
  @media (width < 1248px) {
    display: none;
  }
}
.v-btn.active .v-icon {
  transform: rotate(-180deg);
}
</style>
